import { Component, OnInit } from '@angular/core';
import { ABMRolesService } from '../../../services';
import { MdDialogRef } from '@angular/material';
import { ProductoModel } from '../new-edit-producto-dialog/producto-class';

@Component({
  selector: 'app-new-edit-producto-dialog',
  templateUrl: './new-edit-producto-dialog.component.html',
  styleUrls: ['./new-edit-producto-dialog.component.scss']
})

export class NewEditProductoDialogComponent implements OnInit {

  public isNewProducto: boolean;
  public input_value = '';
  public productosList: any;
  public currentProducto: any;

  titleString: string;
  validString = true;
  special_char_error = false;
  newEditedProducto: ProductoModel;
  duplicatedError = false;

  constructor(private abmService: ABMRolesService,
              private dialogRef: MdDialogRef<NewEditProductoDialogComponent>) {
  }

  ngOnInit() {
    console.log('new or not');
    console.log(this.isNewProducto);
    if (this.isNewProducto) {
      this.titleString = 'Nuevo';
      this.checkInput();
    } else {
      this.titleString = 'Editar';
      this.input_value = this.currentProducto.Producto;
      this.checkInput();
    }
  }


  onSubmit() {
    console.log('submit');
    if (this.input_value.length > 0) {

      this.input_value = this.input_value.trim();
      let duplicado = false;

      if (this.isNewProducto) {
        for (let i = 0; i < this.productosList.length; i++) {
          if (this.input_value === this.productosList[i].Producto) {
            duplicado = true;
          }
        }
      } else {
        for (let i = 0; i < this.productosList.length; i++) {
          if (this.input_value === this.productosList[i].Producto && this.productosList[i].Id !== this.currentProducto.Id) {
            duplicado = true;
          }
        }
      }

      if (duplicado) {
        this.duplicatedError = true;
      } else {
        if (this.isNewProducto) {
          this.insertNewProducto();
        } else {
          this.editProducto();
        }
      }
    }
  }

  insertNewProducto() {
    this.abmService.createProducto(this.generateProduct())
      .subscribe(data => {
        const respose = data;
      });
    console.log('nuevo');
    console.log(this.generateProduct());
    this.dialogRef.close(true);
  }

  editProducto() {
    // si el nombre es el mismo que antes no guardar
    if (this.currentProducto.Producto === this.input_value) {
      console.log('mismo nombre');
      this.dialogRef.close(false);
    } else {
      this.newEditedProducto = new ProductoModel;
      this.newEditedProducto.Id = this.currentProducto.Id;
      this.newEditedProducto.Producto = this.input_value.trim();
      this.newEditedProducto.Basis = this.currentProducto.Basis;
      console.log('editar');
      console.log(this.newEditedProducto);
      this.abmService.editProducto(this.newEditedProducto)
        .subscribe( data => {
          const response = data;
        });
      this.dialogRef.close(true);
    }
  }

  // al hacer cambios en el nombre, chequear que no haya errores
  checkInput () {
    this.duplicatedError = false;
    this.special_char_error = false;
    this.validString = true;

    // chequear que no haya solo espacios solo si hay algo

    if (this.input_value) {
      if (this.input_value.trim().length === 0) {

        this.validString = false;

      } else {
        // si hay algo escrito, ejecutar loop que busca caracteres especiales
        if (this.input_value) {
          for (let i = 0; i < this.input_value.length; i++) {
            if (this.input_value.charAt(i).match(/^[^a-zA-Z0-9 ]/) !== null) {
              this.special_char_error = true;
              this.validString = false;
            }
          }
        }
      }
    } else {
      this.validString = false;
      console.log('case undefined');
    }
  }

  onDelete() {
    if (!this.isNewProducto) {
      this.abmService.deleteProducto(this.currentProducto.Id)
        .subscribe( data => {
          const response = data;
        });
      this.dialogRef.close(true);
    }
  }

  generateProduct() {
    this.newEditedProducto = new ProductoModel;
    this.newEditedProducto.Producto = this.input_value.trim();
    this.newEditedProducto.Basis = false;
    let max = 0;
    for (const temp of this.productosList) {
      if (max < temp.Id) {
        max = temp.Id;
      }
    }
    this.newEditedProducto.Id = max + 1;
    return this.newEditedProducto;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/new-edit-producto-dialog/new-edit-producto-dialog.component.ts